module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"All accounts":"Все счета","All envelopes":"Все конверты","All subtypes":"Все типы","All categories":"Все категории","Search by description":"Поиск по описанию (ИЛИ)","incomes and expenses":"доходы и расходы","unconfirmed":"неподтверждённые","reset":"сбросить"}}')
  delete Component.options._Ctor
}
